import { create } from "zustand";
import { CommonResponseModelWODataArray, orderDetail, orderList } from "../models/axiosModel";
import agent from "../services/api";

let latestOrderListRequestId = 0;

interface orderDetailStoreInterface {
    orderList: orderList[] | null,
    setOrderList: (value: orderList[] | null) => void,

    totalOrders: number,
    setTotalOrders: (value: number) => void,

    totalPaidOrders: number,
    setTotalPaidOrders: (value: number) => void,

    totalNotPaidOrders: number,
    setTotalNotPaidOrders: (value: number) => void,

    totalFilteredOrders: number,
    setTotalFilteredOrders: (value: number) => void,

    limit: number,
    setLimit: (value: number) => void,

    getOrderListApi: (organizationId: number, start: number, limit: number, searchText?: string, flag_paid_only?: boolean, flag_not_paid_only?: boolean) => Promise<CommonResponseModelWODataArray<{ orders: orderList[]; total_orders: number; total_paid_orders: number; total_not_paid_orders: number }>>,

    selectedOrderDetail: orderDetail | null,
    setSelectedOrderDetail: (value: orderDetail | null) => void,

    getOrderDetailApi: (organizationId: number, ecom_order_id: string) => Promise<CommonResponseModelWODataArray<orderDetail>>,
}

export const useOrderDetailStore = create<orderDetailStoreInterface>((set, get) => {

    return {
        orderList: null,
        setOrderList: (value: orderList[] | null) => set({ orderList: value }),

        totalOrders: 0,
        setTotalOrders: (value: number) => set({ totalOrders: value }),

        totalPaidOrders: 0,
        setTotalPaidOrders: (value: number) => set({ totalPaidOrders: value }),

        totalNotPaidOrders: 0,
        setTotalNotPaidOrders: (value: number) => set({ totalNotPaidOrders: value }),

        totalFilteredOrders: 0,
        setTotalFilteredOrders: (value: number) => set({ totalNotPaidOrders: value }),

        limit: 50,
        setLimit: (value: number) => set({ limit: value }),

        getOrderListApi: async (organizationId: number, start: number, limit: number, searchText?: string, flag_paid_only?: boolean, flag_not_paid_only?: boolean) => {
            const requestId = ++latestOrderListRequestId;
            const orderList = get().orderList;
            const totalOrders = get().totalOrders;
            const totalPaidOrders = get().totalPaidOrders;
            const totalNotPaidOrders = get().totalNotPaidOrders;
            const totalFilteredOrders = get().totalFilteredOrders;

            const hasNoFiltersApplied = !searchText && !flag_paid_only && !flag_not_paid_only;

            const res = await agent.listOrders.get(organizationId, null, start, limit, searchText, flag_paid_only, flag_not_paid_only);

            if (requestId !== latestOrderListRequestId) {
                return res;
            }

            if(res?.status){
                const orders = [...(res?.data?.orders ?? [])];
                const totalOrderCount = res?.data?.total_orders ?? 0;
                const totalPaidOrderCount = res?.data?.total_paid_orders ?? 0;
                const totalNotPaidOrderCount = res?.data?.total_not_paid_orders ?? 0;

                set({
                    orderList: orders,
                    totalFilteredOrders: totalOrderCount,
                    ...(hasNoFiltersApplied && 
                        {
                            totalOrders: totalOrderCount,
                            totalPaidOrders: totalPaidOrderCount,
                            totalNotPaidOrders: totalNotPaidOrderCount,
                        }
                    )
                });
            } else {
                set({
                    orderList: orderList ?? null,
                    totalFilteredOrders: totalFilteredOrders,
                    totalOrders: totalOrders,
                    totalPaidOrders: totalPaidOrders,
                    totalNotPaidOrders: totalNotPaidOrders,
                });
            }
            return res;
        },

        selectedOrderDetail: null,
        setSelectedOrderDetail: (value: orderDetail | null) => set({ selectedOrderDetail: value }),

        getOrderDetailApi: async (organizationId: number, ecom_order_id: string) => {
            const res = await agent.listOrders.get(organizationId, ecom_order_id);
            if(res?.status){
                set({ selectedOrderDetail: res?.data })
            } else {
                set({ selectedOrderDetail: null })
            }

            return res;
        }
    }
})
